import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

@UntilDestroy()
@Component({
    selector: 'ifb-advisor-app-bar-title',
    templateUrl: './advisor-app-bar-title.component.html',
    styleUrls: ['./advisor-app-bar-title.component.scss'],
    standalone: false
})
export class AdvisorAppBarTitleComponent implements OnInit {

  title: string;

  constructor(private route: ActivatedRoute,
    private router: Router) { }

  backToAdvisorList() {
    this.router.navigateByUrl('/advisor');
  }

  backToAdvisorDetails() {
    this.router.navigateByUrl(`/advisor/${this.data.advisor.id}/profile`);
  }

  ngOnInit() {
  this.route.data.pipe(untilDestroyed(this)).subscribe(this.dataSet.bind(this));
  }

  data: any;

  dataSet(data: any) {
    this.data = data;
    this.title = data.advisor ? `${data.advisor.fullName || ''}` : '';
  }
}
